import { useTranslation } from "react-i18next";
import Icon from "../../../Icon/Icon";

const TemplateDetails = ({ template }) => {
  const [t] = useTranslation("exports");
  const name = template ? `${t("detailModal.template_title")} ${template.template_name}` : t("detailModal.no_template")
  const fields = template ? template.template_fields : {}

  return (
    <>
      <h5>{name}</h5>
      {fields && (
        <div className="template_list">
          {fields.map(
            (element) => (<>
              <div>
                <div className="field_info">
                  <h6>
                    {element.label}
                  </h6>
                  {
                    element.is_sensitive && (
                      <span className="is_sensitive field-rectangle">
                        {t("detailModal.encrypted_message")} <Icon size={16} name={'warning'} />
                      </span>
                    )
                  }
                  {
                    element.has_catalog && (
                      <span className="has_catalog field-rectangle">
                        {t("detailModal.catalog_message")} <Icon size={16} name={'info_circle'} />
                      </span>
                    )
                  }
                </div>
              </div>
            </>)
          )}
        </div>
      )}
    </>
  )
};

export default TemplateDetails;